import React from 'react'

import LeaderboardItem from '@rewardops/replit/src/components/LeaderboardItem'
import { Card, CardContent } from '@rewardops/replit/src/components/ui/card'
import { Skeleton } from '@rewardops/ui'

import { useApi } from '~/components/hooks/use-api'
import { PAWSectionType } from './paw-section-types'

export const Rankings: React.FC<PAWSectionType> = ({
  content,
  data,
}: PAWSectionType) => {
  const { api } = useApi()

  const { data: rankings, isLoading } = api.pawDashboards.getByRole.useQuery({
    role: data?.role,
    sectionId: 'rankings',
  })

  return (
    <section data-testid={content?.sectionId} id={content?.sectionId}>
      <h2 className="mb-6 text-xl font-semibold">
        {content?.title ?? 'Rankings'}
      </h2>

      {isLoading ? (
        <Skeleton className="h-[400px] w-full" />
      ) : (
        <Card className="overflow-visible">
          <CardContent className="p-6">
            <div className="space-y-1">
              {rankings?.map((entry: any, idx: number) => (
                <LeaderboardItem
                  key={entry?.id ?? entry?.dealerId ?? entry?.locationId}
                  rank={idx + 1}
                  name={entry?.name ?? entry?.dealerName ?? entry?.locationName}
                  points={entry?.points ?? entry?.pointsEarned}
                  isCurrentUser={entry?.isCurrentUser}
                  testIdPrefix="store"
                />
              ))}
            </div>
          </CardContent>
        </Card>
      )}
    </section>
  )
}
